import { call, put, takeEvery } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eThoiKhoaBieuActionIds, IThoiKhoaBieuActionTypes } from "../../action-types/tkb/IThoiKhoaBieuActions";
import { rootActions } from "../../actions/rootActions";
import { xepTkbApi } from "../../../api/tkb/xepTkbApi";

const mainAction = rootActions.tkb.thoiKhoaBieu;

export function* thoiKhoaBieuSaga(): any {
  yield takeEvery(eThoiKhoaBieuActionIds.SELECT_BY_KY_DANG_KY_START, selectByKyDangKyWorker);
}

function* selectByKyDangKyWorker(action: IThoiKhoaBieuActionTypes): any {
  const ky_dang_ky = action.payload as { kyDangKys: number[]};
  const res: IBaseRespone = yield call(xepTkbApi.SelectByKyDangKy, ky_dang_ky.kyDangKys);
  if (res.is_success) {
    yield put(mainAction.SELECT_BY_KY_DANG_KY_SUCCESS(res.data ?? []));
  } else {
    yield put(mainAction.SELECT_BY_KY_DANG_KY_ERRR(res.message ?? "Có lỗi"));
  }
}
